import styles from './styles.module.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFujiAuth } from '../../../auth/useFujiAuth';
import { useTranslation } from 'react-i18next';
import { showNotificationDialog } from '../../../utils';
import Header from '../../../components/header/Header';
import CenterLoading from '../../../components/CenterLoading/CenterLoading';
import FujiModal from '../../../components/fuji-modal/FujiModal';
import ButtonNetwork from '../../../utils/network-connect/ButtonNetwork';
import isOnline from '../../../utils/network-connect/NetworkConnect';
import useR05Api from '../../../api/useR05Api';

/**
 * 図18-1 退会画面
 */
const DeleteUserScreen = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const { deleteUser, signOut } = useFujiAuth();
    const navigate = useNavigate();
    const { deleteUser: deleteUserInfo } = useR05Api();

    /**
     * Okボタン押す時、退会の実行処理
     */
    const handleOk = () => {
        if (isOnline()) {
            //ダイアログを非表示
            setOpen(false);
            //ローディングを表示
            setIsLoading(true);
            localStorage.setItem('isDeleteUser', 'true');
            deleteUser(({ isSuccessed, message }: { isSuccessed: boolean; message: any }) => {
                //ローディングを非表示
                setIsLoading(false);
                localStorage.removeItem('isDeleteUser');
                if (isSuccessed) {
                    //退会完成
                    showNotificationDialog(
                        'success',
                        'delete-account',
                        t('notification.title'),
                        t('notification.delete-acc-success'),
                    );
                    //購入ページに遷移
                    navigate('/buy', { replace: true });
                    return;
                }
                // 退会したアカウントに対して、ログアウトを実行
                if (
                    (message.code && message.code.includes('UserNotFoundException')) ||
                    (message.message && message.message.includes('No current user')) ||
                    (message && message.includes('UserNotFoundException'))
                ) {
                    localStorage.setItem('deleteUser.error', 'UserNotFoundException');
                    signOut(true, ({ isSuccessed }: { isSuccessed: boolean }) => {
                        if (isSuccessed) {
                            localStorage.removeItem('deleteUser.error');
                            // 既に退会済みのエラーメッセンジを表示
                            showNotificationDialog(
                                'failed',
                                'delete-account',
                                t('notification.title'),
                                t('error-message.delete-account.no-user'),
                            );
                            // 購入画面に遷移
                            navigate('/buy', { replace: true });
                        }
                    });
                } else {
                    // MSG.11-E1 退会処理に失敗
                    showNotificationDialog(
                        'failed',
                        'delete-account',
                        t('notification.title'),
                        t('error-message.delete-account.failed'),
                    );
                }
            }, deleteUserInfo);
        } else {
            setOpen(false);
            showNotificationDialog('error', '', t('notification.title'), t('error-message.server-error'));
        }
    };
    const handleCancel = () => {
        setOpen(false);
    };
    return (
        <React.Fragment>
            {isLoading && <CenterLoading overFooter={true} />}
            <Header title={t('header.delete-account')} />
            <div className={`content-footer-container scrollable ${styles.container}`}>
                <div className={styles.content}>
                    <div className={styles.noteContent}>
                        <div className={styles.note}>
                            <p>{t('delete-account.description-message-1')}</p>
                        </div>
                        <div className={styles.note}>
                            <p>{t('delete-account.description-message-2')}</p>
                        </div>
                        <div className={styles.note}>
                            <p>{t('delete-account.description-message-3')}</p>
                        </div>
                        <div className={styles.note}>
                            <p>{t('delete-account.description-message-4')}</p>
                        </div>
                    </div>
                    <ButtonNetwork title={t('my-profile.delete-account')} onClick={() => setOpen(true)} />
                </div>
                {/* 確認モーダルを表示 */}
                <FujiModal
                    isOpen={open}
                    body={t('modal.delete-account-confirmation')}
                    txtSubmit={t('modal.ok')}
                    txtCancel={t('modal.cancel') ?? ''}
                    onSubmit={handleOk}
                    onCancel={handleCancel}
                />
            </div>
        </React.Fragment>
    );
};

DeleteUserScreen.prototype = {};

export default DeleteUserScreen;
